module.exports = __webpack_public_path__ + "img/icon-collapse.9748dbe5.svg";